export const hasEntitlement = (entitlements, productName) => {
    if (!Array.isArray(entitlements)) {
        return false;
    }
    return entitlements.some(
        (entitlement) =>
            entitlement.product === productName && entitlement.status === 'ACTIVE'
    );
};

export const getFilteredRouteData = (routeData, entitlements) => {
    return routeData
        .map((route) => {
            if (route.requiredEntitlement) {
                const hasAccess = hasEntitlement(entitlements, route.requiredEntitlement);
                
                if (!hasAccess) {
                    return null;
                }
                
                if (hasAccess && route.children) {
                    // Filter children based on their individual entitlements
                    const filteredChildren = route.children
                        .map((child) => {
                            if (child.requiredEntitlement) {
                                let childHasAccess = hasEntitlement(entitlements, child.requiredEntitlement);

                                // If child is a WHATSAPP-only page but the user also has CRM,
                                // and there is a top-level CRM page with the same url/component,
                                // prefer showing it in CRM only (hide the duplicate under WhatsApp).
                                if (
                                    childHasAccess &&
                                    child.requiredEntitlement === 'WHATSAPP' &&
                                    hasEntitlement(entitlements, 'CRM')
                                ) {
                                    const topLevelDuplicate = routeData.find((r) => (
                                        (r.url && child.url && r.url === child.url) ||
                                        (r.componentName && child.componentName && r.componentName === child.componentName)
                                    ) && r.requiredEntitlement === 'CRM');

                                    if (topLevelDuplicate) {
                                        childHasAccess = false;
                                    }
                                }

                                return childHasAccess ? child : null;
                            }
                            return child;
                        })
                        .filter((child) => child !== null);
                    
                    return {
                        ...route,
                        children: filteredChildren,
                    };
                }
            }

            return route;
        })
        .filter((route) => route !== null);
};
